export const mainBlue = '#4C5392';
export const lightBlue = '#C6CADE';
export const darkBlue = '#2A2859';
